var _defs, _path, _path2, _path3, _path4, _path5, _text, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle2, _path33, _path34, _path35, _path36, _path37, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path38, _path39, _path40, _path41, _path42, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle9, _circle10, _path55;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError404 = function SvgError404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1041.4 929.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Error_404_svg__a",
    x1: 478.43,
    x2: 478.43,
    y1: 862.98,
    y2: 862.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5f6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#686b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#717475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#87898a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#949798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#999b9c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "m347.2 893.4-14.2-6.2C178.9 816 71.9 660.1 71.9 479.2c0-248 201.1-449 449.1-449s449.1 201 449.1 449c0 179.7-105.6 334.8-258.1 406.6-3.7 1.8-7.5 3.5-11.4 5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.7 441.7v-57.6H176.5V336l124.2-181.8h46.1v181.6h35.5v48.3h-35.5v57.6Zm0-105.9V238l-65.9 97.8ZM501.3 154.2q41.6 0 65 29.7 27.9 35.1 28 116.6t-28.2 116.8q-23.2 29.3-64.8 29.3c-27.9 0-50.3-10.7-67.4-32.1s-25.6-59.6-25.6-114.6 9.4-92.7 28.1-116.4c15.5-19.5 37.2-29.3 64.9-29.3m0 45.5a27 27 0 0 0-17.8 6.4c-5.2 4.2-9.2 11.8-12.1 22.7q-5.7 21.3-5.7 71.7t5.1 69.2c3.4 12.6 7.7 21 12.8 25.1a28 28 0 0 0 35.5-.1c5.2-4.2 9.2-11.8 12.1-22.7q5.5-21.2 5.6-71.5t-5-69.2c-3.4-12.6-7.7-21-12.8-25.2a27 27 0 0 0-17.7-6.4M738.6 441.7v-57.6H621.4V336l124.2-181.8h46.1v181.6h35.6v48.3h-35.6v57.6Zm0-105.9V238l-65.8 97.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M103.2 443.5h154.9v103.15H103.2zM154.9 563.6h103.2v103.15H154.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M103.7 530.2H257v15.69H103.7zM844.6 885.3c0 7.4-211.7 13.3-366.5 13.3s-280.5-5.9-280.5-13.3S323.2 872 478.1 872s366.5 5.9 366.5 13.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M850.7 388.5H735.9a45 45 0 0 0-44.9 44.9v84.3a45.1 45.1 0 0 0 30.4 42.5v33.5l27.3-31.1h102a45 45 0 0 0 44.9-44.9v-84.3a45 45 0 0 0-44.9-44.9Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ef4136",
    fontFamily: "Avenir-Black, Avenir",
    fontSize: 152.85,
    fontWeight: 800,
    transform: "translate(751.2 531.4)"
  }, "?\n    ")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff5ff",
    d: "M417.6 602.8 329 626l35.3-161.2 73.1-58.5s-31.7-23.7-81.1 18L252.8 661.9s29.8 63.3 31.8 60.3 120.3-20.5 120.3-20.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3bb8d9",
    d: "m406.4 604.4-77.1 21.3s-7.8 77.5-44.7 96.5L418 709.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef4136",
    d: "M514.5 570.9s-72.2 8.1-139.4 37.9c0 0 .4 96.9 4.4 106.8s17.9 29.6 17.9 29.6l19 105.9 19.8 19.8 172.2 1.7 18.7-16.9 22.4-112.8c-.2-.1-7.3 26.5-7.3 26.5s76.4-85 83.3-112.8c0 0-73.4-97.8-156.5-91.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M438 440.5s-30.2 25.9-2.9 63.1l14.9 1.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff5ff",
    d: "M551.2 489.5s-2.3 78.9 62.2 92.7c0 0-98.6 49.8-114.5 68.6 0 0-28.3-22.9-48.2-49.6l35.7-13.5s23.2-4.9 7.9-33.1c0 0 35.7-11.5 56.9-65.1M545.5 438s7.6-48.4-21.5-49.7-50 15.5-71.2 11.5c0 0-15.8 6.7-15.8 31.8V515s41.2 48.9 87.4-4.1c.1 0 23.8-45.1 21.1-72.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3bb8d9",
    d: "M553.7 478.6s-9.3 67.2 37.9 95.4c0 0-36.3-19-43.2-26s-12.9 17.4-16.4 23.4-26.3 23.8-39.2 13.4c0 0 14.5-13.5-1.5-33.7M466.3 448.4s7.4-19.8-4.5-24.8c0 0-7.9-3.9-17.9 7.5 0 0 2-20.8 20.4-14.9 0 0 18.4 12.4 2 32.2M480.7 468.8c-1.5 0-22.8-4-22.8-4l6.9 7.8a6.2 6.2 0 0 0 8.1 1.2ZM517.8 390.2s-3.1 6.2-5.2 18.7c0 0-14.6-1.2-16.1 7.7 0 0-1.3 2.7 7.1 2.7a17.5 17.5 0 0 1 10.3 3.5c3.5 2.6 8.2 7 10 13.1 0 0 2.9 8.5-3.5 13.9s-16.3 14.2-12.7 26a17 17 0 0 1-.7 10.9l-4.9 12.8s25.1 15.3 34-8c0 0 18.1-38.7 13-73 0 0-6.3-29.1-31.3-28.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3bb8d9",
    d: "M462 448.8s-1.1-9.7-2.7-9.9-10.3-1.1-11.9 11.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b0f0",
    d: "m445 493.6-8.2-14.3-4.6 46.1s-1.9 28.3 14.5 32.2c0 0 10.9 1.5 17.3 8.9s86.4-15.5 88.2-80l-9.9-11.4s-6.4 17.4-15.9 20.9-29.8-7.4-31.7-9.4-31.3-20.3-49.7 7M440.4 414.2a25.7 25.7 0 0 1 12.4-14.4s17.4 6 46.7-6 57.1 11.5 43.2 49.2l28.3 12.7s37-50.8 6.2-70.6c0 0-19.1-16.6-40.6-23.1 0 0 1-11.9 7.4-12.4s-18.3-13.4-45.1 1.5c0 0-1.5-8.4 3.4-9.9s-50.6-4.4-46.5 37.3c0 0-22.8 10.4-15.4 35.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1067a1",
    d: "M505.5 492.8s15.6 40.4-40.3 74.7c0 0 3.2 6.2 12.5 6.2s61.4-7.9 78.7-75.5l-13.6-30.3s-3.1 37.3-37.3 24.9M517.8 390.2s6.2-21.8 18.6-28c0 0 52.9 15.4 56 40.3 1.7 12.9 3.2 31.1-15.4 49.8-23.3 23.3-34.3-3.1-34.3-3.1s9.3-46.6-24.9-59"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M536.8 362s44 6.8 41.6 69.9c0 0 27.6 36.9-4.8 69-26.5 26.1-45.7-42.6-31.4-63 0 0 5.2-8.2 17.9-7 0 0 5.5-49.1-23.3-68.9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.3,
    cy: 464.9,
    fill: "#e3e329",
    rx: 16.6,
    ry: 27.5,
    transform: "rotate(-.1 572.558 458.866)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff5ff",
    d: "M457 501.1s11.9-10 30.4.6c0 0-12.5 9.2-30.4-.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3bb8d9",
    d: "m364.3 464.8 73.1-58.5s-43.2-11.6-66.6 25.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M504.8 770.3c-69.2.1-103.6-15-105.9-16.1l-1.5-8.9c.8.4 104.5 37.1 257.4-4.7l-3.7 9.1c-54.6 14.9-109.1 20.5-146.3 20.6M506 801.3c-66.7.1-99.8-15-102.1-16.1l-1.4-8.9c.8.4 84.6 37.8 226.3.1l15.1-4.5-1.4 8.9-15.1 4.5a457.4 457.4 0 0 1-121.4 16"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff5ff",
    d: "M720.1 660.2s32.4 125.6 1.5 212.6c-2.3 6.8-33 2.2-33 2.2s-43.2 5.9-83.6-1.5c-19.7-3.6-42.7-10.7-67-17.2 0 0-39.2-10.3-71.7-10.3-2.8 0-16.4 8.3-21.8 7.2s5.4-29.7 15.4-40.4 51.7-26.1 51.7-26.1l54.5 41.4s53.8-22.9 83.7-21.1c0 0-6.6-29.8 1.9-58.8a18 18 0 0 1 1.3-3.4c11.1-25.7 67.1-84.6 67.1-84.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3bb8d9",
    d: "M571 827.1s62.5-31 93.7-16.4l19.6 7.8s-40-10-113.3 8.6M720.1 660.2s-49.8 49.5-66.3 82.5c0 0-3.6 6.3-5.1 19.5 0 0 22.6-34.2 80.4-55.5 0 0-4.4-36.3-9-46.5M663.4 877s23.1-5 29.6-12c0 0 6.5 5.8 25.2 8.9.6.1 2.2-.1 2.7 0s-6.3 5.9-32.5 1.5c0 0-20.3 1.5-25 1.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8b8b",
    d: "M296.8 866.9s-2 3.7 12.1 6.8h295.5s9.9-.7 12.5-5.3v-2.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8b8b",
    d: "M296.9 862.7H617v5.5s.5 1.1-3.3.8H299.9s-3 .8-3.2-1.1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Error_404_svg__a)",
    d: "M478.4 863"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8b8b",
    d: "M585.5 869.5V722.1a13.7 13.7 0 0 0-13.7-13.7H341.9a13.7 13.7 0 0 0-13.7 13.7v147.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 456.9,
    cy: 794,
    r: 15.5,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M825.3 820.8h-60.6l1.6 26.5a59.6 59.6 0 0 0 12.1 32.9 20.3 20.3 0 0 0 2.6 3.1c0 1.1 6.3 2 14 2s14.1-.9 14.1-2a30 30 0 0 0 2.7-3.2 60.3 60.3 0 0 0 12-33Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M825.3 820.8c0 2.4-13.5 4.4-30.3 4.4s-30.3-2-30.3-4.4 13.6-4.3 30.3-4.3 30.3 1.9 30.3 4.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M818.7 820.8c0 1.4-10.7 2.6-23.8 2.6s-23.7-1.2-23.7-2.6 10.6-2.5 23.7-2.5 23.8 1.1 23.8 2.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M828.8 765.9c0-6.7-1.1-13.1-3.9-18.5-4.5-8.6-13.4-14.4-29.2-14.4h-.8c-15.8 0-24.7 5.8-29.2 14.4-2.8 5.4-3.9 11.8-3.9 18.5-.1 25 14.4 54.9 14.4 54.9h38.2s14.5-29.9 14.4-54.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M785.9 821.1c-15.3-52.3-9.6-84.5-9.6-84.8l1.6.3c-.1.3-5.7 32.1 9.6 84ZM807.5 821l-1.6-.4c13.9-51.2 8.8-82.6 8.7-82.9l1.6-.3c.1.3 5.3 32-8.7 83.6M796.1 820.9h-1.6c3.8-52.5 1.4-87.4 1.4-87.8h1.6c0 .2 2.4 35.2-1.4 87.8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "m827.174 760.854 7.412-1.147.245 1.581-7.412 1.147zM825.463 778.901l7.412-1.147.245 1.581-7.412 1.147zM755.748 766.608l.256-1.584 7.405 1.197-.256 1.584zM763.485 803.29l.261-1.578 7.38 1.222-.261 1.578z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffcfc",
    d: "M805.3 846c-3.4-5.7-10.4 2.5-10.4 2.5s-7-8.2-10.3-2.5 7.1 18.8 10.3 18.8 13.9-13 10.4-18.8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M181.9 476.1H180v-1.9a2 2 0 0 1 1.9 1.9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.7,
    cy: 475.4,
    r: 0.2,
    fill: "#dbdbdb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M229.2 485h-99.4a1.2 1.2 0 0 1-1.2-1.1 1.2 1.2 0 0 1 1.2-1.2h99.4a1.2 1.2 0 0 1 1.2 1.2 1.1 1.1 0 0 1-1.2 1.1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M234.7 503.7v18.4H127v-21.2c0-3.3 1.3-4.5 1.3-4.5a90 90 0 0 1 1.1-9.1v-.3a3.6 3.6 0 0 0 .2-1.1c.1-.3.1-.6.2-.9a15.5 15.5 0 0 1 .8-2.3 17.8 17.8 0 0 1 5.6-6.6h80.9a12.4 12.4 0 0 1 10.9 6.6l.5 1.1c.1.4.3.8.4 1.2l.9 2.3c.1.2.1.4.2.6 1.2 3.2 2.3 6.5 3.2 9 .3.8.5 1.6.7 2.2a11.5 11.5 0 0 1 .7 3.6 3.1 3.1 0 0 1 .1 1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M197 487.1a42.3 42.3 0 0 1-13.8 10.4 40.9 40.9 0 0 1-17 3.7h-39.3v-.2c0-3.4 1.3-4.6 1.3-4.6s.1-2.6 1.1-9.1a.3.3 0 0 1 .1-.2ZM234.7 503.7v18.4H127v-19.4h107.6a3.1 3.1 0 0 1 .1 1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M233.3 508.3h2.7v8.2h-2.7a1.2 1.2 0 0 1-1.2-1.2v-5.8a1.2 1.2 0 0 1 1.2-1.2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M237.3 512.4c0 2.2-.6 4.1-1.3 4.1s-1.4-1.9-1.4-4.1.6-4.1 1.4-4.1 1.3 1.8 1.3 4.1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.9,
    cy: 522.3,
    r: 9.3,
    fill: "#dbdbdb",
    transform: "rotate(-45 209.922 522.247)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.9,
    cy: 522.3,
    r: 4.8,
    fill: "#dbdbdb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.9,
    cy: 522.3,
    r: 3.2,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 522.3,
    r: 9.3,
    fill: "#dbdbdb",
    transform: "rotate(-45 148.071 522.367)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 522.3,
    r: 4.8,
    fill: "#dbdbdb"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 522.3,
    r: 3.2,
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "m138.8 522.3 3.8-3.9h11.2l3.7 3.7h3.5v-10.4h-22.2zM127 517v-7.1h1.6v5.4a1.6 1.6 0 0 1-1.6 1.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234.7 504.6H126.3a1 1 0 0 1-1-.9 1 1 0 0 1 1-1h108.4a.9.9 0 0 1 1 1 .9.9 0 0 1-1 .9M132.4 506.6h5.9v.82h-5.9zM132.4 508.3h5.9v.82h-5.9zM132.4 509.9h5.9v.82h-5.9zM132.4 511.6h5.9v.82h-5.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M229.3 486a4.2 4.2 0 0 0-.4-1h-99.1c-.1.3-.1.6-.2.9h99.7ZM203.7 476.1a68.7 68.7 0 0 1-24.6 4.5h-47.3a17.2 17.2 0 0 1 4.4-4.5ZM233.2 496.9h-4.9l-1.3-7.1a1.7 1.7 0 0 1 1.7-1.9h1.3l.3.9c1.1 2.9 2.1 5.8 2.9 8.1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M233.2 496.9h-3.5l-1.2-6.2a1.7 1.7 0 0 1 1.7-1.9h.1c1.1 2.9 2.1 5.8 2.9 8.1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m225.2 487.9 1.8 9h-26.2a2.9 2.9 0 0 1-2.8-2.9v-3.2a2.9 2.9 0 0 1 2.8-2.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 9,
    x: 183.4,
    y: 487.9,
    fill: "#fff",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 9,
    x: 169.3,
    y: 487.9,
    fill: "#fff",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 9,
    x: 155.2,
    y: 487.9,
    fill: "#fff",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 4.7,
    x: 220,
    y: 520,
    fill: "#dbdbdb",
    rx: 1.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 4.7,
    x: 125.3,
    y: 520,
    fill: "#dbdbdb",
    rx: 1.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 43.4,
    height: 4.7,
    x: 157.3,
    y: 520,
    fill: "#dbdbdb",
    rx: 1.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M161.6 504.6h.9v15.32h-.9zM197.5 504.7h.9v15.32h-.9zM163.8 505.5h4v1.47h-4zM199.7 505.5h4v1.47h-4zM147.4 473.3h1v2.73h-1zM180.8 473.3h1v2.73h-1zM214.3 473.3h1v2.73h-1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M142.9 473.3h75.9v1.01h-75.9zM221.5 578.8c.1-.5.2-.7.4-1.4s.5-3.4-.2-4.1-1.7.4-1.4 2.5a5.9 5.9 0 0 0 1.2 3M201.3 592.2l-8.8 5.2c-1.6.8-2 0-4.5 1s-5.2 2.4-7 1.8-6.1-1.5-5.3-.8 3.6 1.3 3.9 2 1.7 1.1 3.2.7 5.2-.4 6.6-.9l3.6-1.2 6.6-1.6Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "m197.2 597.8-4.5.9c-1.5.2-3.4 2.4-4.2 2.7a9.1 9.1 0 0 0 2.5-.7 37.3 37.3 0 0 1 6.6-1.8M176.4 599.9l1 .2c.6.1 2.3.2 2.7.7s.5 1.2.7 1.4a1.5 1.5 0 0 1-1.1-.7c-.3-.6-2.1-1.1-2.2-1.2Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M202 592.2s-1-.4-2.3 1.2-4.3 4.7-2.2 7.2v6.1a22.5 22.5 0 0 0 1.1 4.3c.6 1.7 7.9.1 7.4-1.6s-.8-3.9.1-5.5c1.8-3.2 2.5-4.5 2.3-5.9s-1.1-3.4-.5-5.2l-1.4-.6Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M203.5 589.7s.2 2.1-1.5 2.5a2.8 2.8 0 0 0 4.5 0 5.1 5.1 0 0 1-.4-2.7Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M206.1 590.8v-.4h-2.8a6 6 0 0 1-.1 1 1.2 1.2 0 0 1-.7 1l-.5.2a4.1 4.1 0 0 0 1.7 1.1c.3.1-.3-.9 0-1.6s1.5.3 2.4-1.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M208.6 586.2a7.5 7.5 0 0 0 .2-3.7c-.6-1.4-1.6-1.6-3.5-1.7s-2.9.3-3.7 1.7a4.7 4.7 0 0 0-.3 3.2 17 17 0 0 0 .4 2.2c.2.8.4.9 1.4 2s1.1.9 1.6.9.8.1 1.7-.7 1.1-1 1.4-1.7.5.4.7-.2l.4-.7c.3-.4.3-1.2-.3-1.3M208.8 654c-.3 1.1-.7 3.2.3 3.6s3.5-3.8 3.7-4.5-.6-1.3 0-2.1 1.3-.4 1.3-.4l.7-1.4s-1.9-2.2-3.2-1.8Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M204.4 583.7s3.7-1.1 3.9 2.6h.6c.3-.1.8-1 .4-2.6a3.4 3.4 0 0 0-4-2.9l-1.3.4v.8ZM198.1 611.7s-2.9 14.3-3.3 17.8-1.4 5.1 1.1 7.5 12.6 11.3 13.4 12.2-1.1 6.2-.3 6.5 1.2-.6 1.6-1.6 1-3.4 1.5-4 1.1-1.8.4-2.3-1.5-.2-2.3-1.1c-5.1-6.4-4.1-8.4-8.2-11.7l-2.7-2 1.4-14.2ZM213.3 621.4a2.1 2.1 0 0 1 1-2.1l1.9 1s-.7.7-.2 1.1 1.2-.3 2 0 4.4 2.7 4.5 3.8-2.9.3-3.6-.1Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "m196 622.2-.5 3.2a7.1 7.1 0 0 1 2.5.8c.7.3-.4 5.5-.6 7.5a3 3 0 0 0 2.3 3c5.5 1.4 7.4 7 8.7 8.9s2.8 1.8 2.8 1.8-2.3-2.4-3-3.5-3.2-7.1-6.6-9.2 1.3-6.6 1.3-6.6a21.5 21.5 0 0 0 1.5-4.2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M198.4 609.9a76.5 76.5 0 0 0-1.1 13.6c0 8.1.2 11.4 2.1 12.1s14.3-10.1 15.1-10.8 4.4.3 5.3.4-1-1.5-3.1-2.3-1.9-2.1-2.8-2.1-.4 1.2-1.4 2-1.7 2-4.7 2.7c-.9.2-2.8-.8-4.6 2l2.4-7.7c.8-2.7 2.1-3.8 2-6.3a1.5 1.5 0 0 0-.4-1.1Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "m198.4 609.9-3.5 14.8s9.5 2.5 12.7-1.9a17.5 17.5 0 0 1 0-5.9c.6-2.4.9-6.6-1.8-8.7ZM206.6 598.9c-1.5-.7-1.4-3.9.3-5.6s5.6-3.8 6.7-4.9 2.9-4.5 4.4-6.6 2.5-2.9 2.3-3.9-.7-2.3-.3-2.3.4 0 .6.9 1.3 1 .8 2.9a69 69 0 0 1-3.9 9.3c-1.4 2.3-3.5 4.1-5.7 6.4s-3.8 4.5-5.2 3.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M213.8 588.1a22 22 0 0 0-.9 2.3c-.3 1-2.9 1.4-5 3.5s-2.2 4.1-2.2 4.1a4.8 4.8 0 0 1 1.9-5.3s3.1-2.1 6.2-4.6M221.7 578a7 7 0 0 0-.7 1c-.8 1.3-3.2 6.4-3.5 9.7 0 0 3.4-6.1 4.2-10.7M203.2 627.5s-1.2 2.8-1.4 3.6.2-2 6.4-5.1a13.1 13.1 0 0 0 4.7-3.5 16.6 16.6 0 0 1-3.5 2.2 27 27 0 0 1-3 .4 5.6 5.6 0 0 0-3.2 2.4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.1,
    cy: 588.3,
    r: 0.5,
    fill: "#dbdbdb"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.7,
    cy: 588.1,
    r: 0.5,
    fill: "#dbdbdb"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "m197.3 625.1.4-7.3-2.2 7zM207.9 615.4a6.8 6.8 0 0 1-2.3 3c-1.4.9 2 4.4 2 4.4a19 19 0 0 1-.1-5.2s.3-1.4.4-2.2M208.5 598.5s-1.6 1.6-2.8-.6a10.2 10.2 0 0 0-1.1 6.6c.3 1.5.9 3.7.9 3.7h.3a12.8 12.8 0 0 1-.1-3c.4-2.2 2.6-3.9 2.8-6.7"
  })));
};
export default SvgError404;